/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CoursefinancialCoursefinancialidClasses201,
  PostApiV1CoursefinancialCoursefinancialidClasses400,
  PostApiV1CoursefinancialCoursefinancialidClasses401,
  PostApiV1CoursefinancialCoursefinancialidClasses404,
  PostApiV1CoursefinancialCoursefinancialidClasses500,
  PostApiV1CoursefinancialCoursefinancialidClassesMutationRequest,
  PostApiV1CoursefinancialCoursefinancialidClassesMutationResponse,
  PostApiV1CoursefinancialCoursefinancialidClassesPathParams,
} from "../../types/courseFinancialClassesController/PostApiV1CoursefinancialCoursefinancialidClasses.ts";
import { courseFinancialClassStudentEditorViewModelSchema } from "../courseFinancialClassStudentEditorViewModelSchema.ts";
import { courseFinancialClassStudentViewModelSchema } from "../courseFinancialClassStudentViewModelSchema.ts";

export const postApiV1CoursefinancialCoursefinancialidClassesPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClassesPathParams>;

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1CoursefinancialCoursefinancialidClasses201Schema = z.lazy(
  () => courseFinancialClassStudentViewModelSchema,
) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClasses201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CoursefinancialCoursefinancialidClasses400Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClasses400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CoursefinancialCoursefinancialidClasses401Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClasses401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1CoursefinancialCoursefinancialidClasses404Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClasses404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CoursefinancialCoursefinancialidClasses500Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClasses500>;

export const postApiV1CoursefinancialCoursefinancialidClassesMutationRequestSchema =
  z.lazy(
    () => courseFinancialClassStudentEditorViewModelSchema,
  ) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClassesMutationRequest>;

export const postApiV1CoursefinancialCoursefinancialidClassesMutationResponseSchema =
  z.lazy(
    () => postApiV1CoursefinancialCoursefinancialidClasses201Schema,
  ) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidClassesMutationResponse>;
